import { useEffect, useState, useCallback } from "react";
import { PollyService, PollyVoice } from "@/services/PollyService";
import { useFirebaseAuth } from "@/state/FirebaseAuthContext";

let cachedPollyVoices: PollyVoice[] | null = null;
let isFetchingPolly = false;

export function useVoices() {
  const { user } = useFirebaseAuth();
  const [localVoices, setLocalVoices] = useState<SpeechSynthesisVoice[]>([]);
  const [pollyVoices, setPollyVoices] = useState<PollyVoice[]>([]);

  const fetchPolly = useCallback(async () => {
    if (cachedPollyVoices && cachedPollyVoices.length > 0) {
      setPollyVoices(cachedPollyVoices);
      return;
    }
    if (isFetchingPolly) return;

    if (navigator.onLine && user && !user.isAnonymous) {
      try {
        isFetchingPolly = true;
        const voices = await PollyService.fetchPollyVoices();
        cachedPollyVoices = voices;
        setPollyVoices(cachedPollyVoices);
      } catch (e) {
        console.debug("Failed to fetch Polly voices", e);
      } finally {
        isFetchingPolly = false;
      }
    }
  }, [user]);

  useEffect(() => {
    fetchPolly();
  }, [fetchPolly]);

  useEffect(() => {
    if (typeof window !== "undefined" && "speechSynthesis" in window) {
      const updateLocalVoices = () => {
        setLocalVoices(window.speechSynthesis.getVoices());
      };

      updateLocalVoices();
      window.speechSynthesis.onvoiceschanged = updateLocalVoices;

      return () => {
        window.speechSynthesis.onvoiceschanged = null;
      };
    }
  }, []);

  return [...localVoices, ...pollyVoices];
}
